<div class="avatar">
	<au-round-avatar [data]="avatarData" [size]="48" />
</div>
<div class="message-content">
	<h4>You</h4>
	<p [innerText]="message.content"></p>
</div>
